import { Injectable } from '@angular/core';
import {Company } from "../models/company";
import { User } from "../models/user";
// TODO: stephen only used for mocking the service right now...
import {UserService} from "./user.service";
import { HTTPService } from 'app/shared/services/http.service';

class CompanyUserStatistic {
    role_name:string;
    role_id:number;
    username:string;
    id:number;
    client_count:number;
}

@Injectable()
export class CompanyService {

    constructor(private userService:UserService, private http:HTTPService) {
    }

    getCompany(id:number) {
        return this.http.get("/admin/companies/" + id + ".json").then((response) => {
            let data = response.json();
            return this.hydrateCompanyFromData(data);
        });
    }

    getCompanies() : Promise<Company[]> {
        return this.http.get("/admin/companies", {limit: 1000}).then((response) => {
            let data = response.json();
            if (!(data.results && data.results.length)) {
                return [];
            }
            return data.results.map(r => this.hydrateCompanyFromData(r));
        });
    }

    getUserStatistics(companyId:number) : Promise<CompanyUserStatistic[]> {
        return this.http.get("/admin/companies/" + companyId + "/users").then((response) => {
            let data = response.json() as CompanyUserStatistic[];
            return data;
        });
    }

    getOrderStatistics(companyId:number) : Promise<any[]> {
        return this.http.get("/admin/companies/" + companyId + "/orders").then((response) => {
            let data = response.json();
            return data;
        });
    }

    createCompany(company:Company) : Promise<Company> {
        // TODO: stephen need to handle the new user password
      return this.http.post("/admin/companies", company).then((response) => {
        let data = response.json();  
        return this.hydrateCompanyFromData(data);
      });
    }

    registerNewCompany(company:Company, authToken:string) : Promise<Company>{
      // TODO: stephen need to handle the new user password
      return this.http.post("/companies", {company: company, authToken:authToken}).then((response) => {
        let data = response.json();  
        return this.hydrateCompanyFromData(data);
      });
    }

    saveAccountOwnerCompany(company:Company) {

        return this.http.post("/companies/" + company.id + ".json", company).then((response) => {
            let data = response.json();
            return this.hydrateCompanyFromData(data);
        });
    }

    getAccountOwnerCompany(id:number) {
        return this.http.get("/companies/" + id + ".json").then((response) => {
            let data = response.json();
            return this.hydrateCompanyFromData(data);
        });
    }

    private hydrateCompanyFromData(record:any) {
        let company = new Company();
        Object.assign(company, record);
        company.email = record._primaryContactEmail;
        let user = new User();
        Object.assign(user, record._user);
        company.user = user;
        return company;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/company.service.ts